import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AbstinenceData } from "./abstinence-modal.interface";

@Component({
  selector: "app-abstinence-modal",
  templateUrl: "./abstinence-modal.component.html",
  styleUrls: ["./abstinence-modal.component.scss"],
})
export class AbstinenceModalComponent implements OnInit {
  @Input() personName: string = "";
  @Input() abstinences: AbstinenceData[] = [];
  @Input() isSaving: boolean = false;
  @Input() maxLength: number = 255;

  @Output() editAbstinence = new EventEmitter<AbstinenceData>();
  @Output() deleteAbstinence = new EventEmitter<string>();
  @Output() createAbstinence = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<AbstinenceData>();
  @Output() fileSelected = new EventEmitter<File>();

  formAbstinence: FormGroup;
  selectedFile: File | null = null;

  // Colunas da tabela
  displayedColumns: string[] = ["description", "startDate", "endDate", "document", "actions"];

  constructor() {
    this.formAbstinence = new FormGroup({
      id: new FormControl(null),
      personId: new FormControl(""),
      description: new FormControl("", Validators.maxLength(this.maxLength)),
      document: new FormControl(null),
      startDate: new FormControl("", Validators.required),
      endDate: new FormControl("", Validators.required),
    });
  }

  get abstinenceDescription() {
    return this.formAbstinence.get("description");
  }

  get remainingCharacters(): number {
    const currentLength = this.abstinenceDescription?.value?.length || 0;
    return this.maxLength - currentLength;
  }

  onEdit(abstinence: AbstinenceData): void {
    this.editAbstinence.emit(abstinence);
  }

  onDelete(id: string): void {
    // Confirmação de exclusão para melhor UX
    if (confirm("Tem certeza que deseja excluir este atestado? Esta ação não pode ser desfeita.")) {
      this.deleteAbstinence.emit(id);
    }
  }

  openDocument(abstinence: AbstinenceData): void {
    if (this.hasDocument(abstinence)) {
      const link = this.getDocumentLink(abstinence);
      window.open(link, "_blank", "noopener,noreferrer");
    }
  }

  onCreate(): void {
    this.createAbstinence.emit();
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileSelected.emit(file);
    }
  }

  onSubmit(): void {
    if (this.formAbstinence.valid) {
      const formData: AbstinenceData = {
        id: this.formAbstinence.get("id")?.value,
        personId: this.formAbstinence.get("personId")?.value,
        description: this.formAbstinence.get("description")?.value,
        startDate: this.formAbstinence.get("startDate")?.value,
        endDate: this.formAbstinence.get("endDate")?.value,
        document: this.formAbstinence.get("document")?.value,
      };
      this.submitForm.emit(formData);
      this.isSaving = false;
    }
  }

  resetForm(): void {
    this.formAbstinence.reset();
    this.selectedFile = null;
  }

  patchForm(abstinence: AbstinenceData): void {
    this.formAbstinence.patchValue(abstinence);
  }

  hasDocument(abstinence: AbstinenceData): boolean {
    return !!abstinence.document;
  }

  getDocumentLink(abstinence: AbstinenceData): string {
    return abstinence.document || "#";
  }

  isDocumentAvailable(abstinence: AbstinenceData): boolean {
    return this.hasDocument(abstinence);
  }

  formatDate(date: string | Date): string {
    if (!date) return "";
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleDateString("pt-BR");
  }

  ngOnInit(): void {
    // Configurar personId se necessário
    if (this.formAbstinence.get("personId")?.value) {
      this.formAbstinence.get("personId")?.setValue(this.formAbstinence.get("personId")?.value);
    }
  }
}
